<h2 mat-dialog-title>Delete {{ data.itemType }}</h2>
<mat-dialog-content>
  Are you sure you want to
  <strong>delete {{ data.itemType }} 
    <ng-container *ngIf="data.itemName">"{{ data.itemName }}"</ng-container>
  </strong>?
  <p *ngIf="data.warning" style="color: red; margin-top: 10px;">
    {{ data.warning }}
  </p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button (click)="onCancel()">Cancel</button>
  <button mat-flat-button (click)="onConfirm()">Delete</button> 
</mat-dialog-actions>